<!-- v.qq.com 腾讯视频 → iframe 嵌入 -->
<iframe *ngIf="isIframeMode && iframeSrc" [src]="iframeSrc" width="100%" height="400" frameborder="0"
    allow="autoplay; encrypted-media" allowfullscreen>
</iframe>

<!-- .mp4 直链 / /download/video/ 下载链接 → <video> 播放 -->
<div *ngIf="isVideoMode" class="video-modal-player">
    <!-- loading -->
    <div *ngIf="isLoading" class="video-modal-loading">
        <nz-spin [nzSize]="'large'"></nz-spin>
        <p class="video-modal-loading-text">视频加载中...</p>
    </div>

    <!-- 视频播放器 -->
    <video *ngIf="!isLoading && !hasError && videoSrc"
        [src]="videoSrc"
        controls muted playsinline webkit-playsinline preload="auto"
        class="video-modal-element"
        (loadeddata)="isLoading = false"
        (error)="onVideoError()">
        您的浏览器不支持视频播放。
    </video>

    <!-- 错误提示 -->
    <div *ngIf="hasError" class="video-modal-error">
        <p>视频加载失败</p>
    </div>
</div>
